export default {
  formId: 'personalInfo',
  formField: {
    maritalStatus: {
      name: 'maritalStatus',
      label: 'Marital Status',
      requiredErrorMsg: 'Please select a marital status'
    },
    ethnicity: {
      name: 'ethnicity',
      label: 'Ethnicity',
      requiredErrorMsg: 'Please select an ethnicity'
    },
    race: {
      name: 'race',
      label: 'Race',
      requiredErrorMsg: 'Please select races that apply'
    },
    religion: {
      name: 'religion',
      label: 'Religious Preference',
      requiredErrorMsg: 'Please select a preferred religion'
    },
    language: {
      name: 'language',
      label: 'Preferred Language',
      requiredErrorMsg: 'Please select a preferred language'
    },
    emailAddress: {
      name: 'emailAddress',
      label: 'Email Address',
      requiredErrorMsg: 'Please provide an email'
    },
    mobileNumber: {
      name: 'mobileNumber',
      label: 'Mobile Phone',
      requiredErrorMsg: 'Please provide a mobile number'
    },
    homeNumber: {
      name: 'homeNumber',
      label: 'Home Phone',
      requiredErrorMsg: 'Please enter valid home phone number'
    },
    workNumber: {
      name: 'workNumber',
      label: 'Work Phone',
      requiredErrorMsg: 'Please enter a valid work phone number'
    },
    preferredNumber: {
      name: 'preferredNumber',
      label: 'PreferredNumber',
      requiredErrorMsg: 'Please select a preferred phone number'
    },
    homeAddress: {
      name: 'homeAddress',
      label: 'Home Address',
      requiredErrorMsg: 'Please provide a home address'
    },

    // Start of the additional contact fields
    additionalCheckBoxApproval: {
      name: 'additionalCheckBoxApproval',
      requiredErrorMsg: 'Please check the box'
    },
    addAdditionalContact: {
      name: 'addAdditionalContact',
      requiredErrorMsg: 'Please select one'
    },
    additionalFirstName: {
      name: 'additionalFirstName',
      label: 'First Name',
      requiredErrorMsg: 'First name is required'
    },
    additionalLastName: {
      name: 'additionalLastName',
      label: 'Last Name',
      requiredErrorMsg: 'Last name is required'
    },
    additionalRelationshipToPatient: {
      name: 'additionalRelationshipToPatient',
      label: 'Relationship to Patient',
      requiredErrorMsg: 'Your relationship to the patient is required'
    },
    additionalContactPhoneNumber: {
      name: 'additionalContactPhoneNumber',
      label: 'Preferred Telephone Number',
      requiredErrorMsg: 'Please enter your preferred phone number'
    }
  }
};
